(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  const gigglzDesktopMenu = window.matchMedia(
    '(min-width: 990px) and (hover: hover)'
  );

  function closeGigglzMenu(details) {
    details.removeAttribute('open');

    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', 'false');
  }

  function openGigglzMenu(details) {
    document
      .querySelectorAll('.header__inline-menu details.mega-menu[open]')
      .forEach((openMenu) => {
        if (openMenu !== details) {
          closeGigglzMenu(openMenu);
        }
      });

    details.setAttribute('open', '');

    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', 'true');
  }

  function initialiseGigglzMenus(root = document) {
    root
      .querySelectorAll(
        '.header__inline-menu details.mega-menu[data-gigglz-menu-url]'
      )
      .forEach((details) => {
        if (details.dataset.gigglzInitialised === 'true') return;

        details.dataset.gigglzInitialised = 'true';

        const summary = details.querySelector(':scope > summary');
        const panel = details.querySelector(':scope > .mega-menu__content');
        const destination = details.dataset.gigglzMenuUrl;

        if (!summary || !panel || !destination) return;

        let closeTimer;

        const cancelClose = () => {
          window.clearTimeout(closeTimer);
        };

        const scheduleClose = () => {
          if (!gigglzDesktopMenu.matches) return;

          window.clearTimeout(closeTimer);

          /*
           * Give the pointer time to cross the small gap between
           * the top-level label and the absolutely positioned panel.
           */
          closeTimer = window.setTimeout(() => {
            if (!details.contains(document.activeElement)) {
              closeGigglzMenu(details);
            }
          }, 350);
        };

        summary.addEventListener('mouseenter', () => {
          if (!gigglzDesktopMenu.matches) return;

          cancelClose();
          openGigglzMenu(details);
        });

        summary.addEventListener('mouseleave', scheduleClose);

        panel.addEventListener('mouseenter', () => {
          if (!gigglzDesktopMenu.matches) return;

          cancelClose();
          openGigglzMenu(details);
        });

        panel.addEventListener('mouseleave', scheduleClose);

        details.addEventListener('focusin', () => {
          if (!gigglzDesktopMenu.matches) return;

          cancelClose();
          openGigglzMenu(details);
        });

        details.addEventListener('focusout', (event) => {
          if (
            gigglzDesktopMenu.matches &&
            !details.contains(event.relatedTarget)
          ) {
            scheduleClose();
          }
        });

        /*
         * Desktop click navigates to the top-level collection.
         * Touch/mobile retains Dawn's normal expand behaviour.
         */
        summary.addEventListener(
          'click',
          (event) => {
            if (!gigglzDesktopMenu.matches) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            window.location.assign(destination);
          },
          true
        );

        details.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;

          cancelClose();
          closeGigglzMenu(details);
          summary.focus();
        });
      });

    /*
     * Moving sideways to another top-level item should close the
     * previous mega menu immediately. The 350ms safety delay is
     * retained only for moving down into the open panel.
     */
    root
      .querySelectorAll(
        '.header__inline-menu > .list-menu--inline > li'
      )
      .forEach((topLevelItem) => {
        if (topLevelItem.dataset.gigglzTopLevelInitialised === 'true') return;

        topLevelItem.dataset.gigglzTopLevelInitialised = 'true';

        const closeOtherMegaMenus = () => {
          if (!gigglzDesktopMenu.matches) return;

          const ownMegaMenu = topLevelItem.querySelector(
            ':scope > header-menu > details.mega-menu'
          );

          document
            .querySelectorAll('.header__inline-menu details.mega-menu[open]')
            .forEach((openMenu) => {
              if (openMenu !== ownMegaMenu) {
                closeGigglzMenu(openMenu);
              }
            });
        };

        topLevelItem.addEventListener('mouseenter', closeOtherMegaMenus);
        topLevelItem.addEventListener('focusin', closeOtherMegaMenus);
      });
  }

  initialiseGigglzMenus();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseGigglzMenus(event.target);
  });

  /*
   * Mobile category groups stay on one screen as accordions.
   * Capture the click before Dawn treats the nested <details>
   * as another full-screen drawer level.
   */
  function initialiseGigglzMobileAccordions(root = document) {
    root
      .querySelectorAll('.gigglz-mobile-accordion > summary')
      .forEach((summary) => {
        if (summary.dataset.gigglzAccordionInitialised === 'true') return;

        summary.dataset.gigglzAccordionInitialised = 'true';

        summary.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            const details = summary.parentElement;
            const willOpen = !details.open;

            /* Keep only one group expanded at a time. */
            details
              .closest('.menu-drawer__menu')
              ?.querySelectorAll('.gigglz-mobile-accordion[open]')
              .forEach((openGroup) => {
                if (openGroup === details) return;

                openGroup.open = false;
                openGroup
                  .querySelector(':scope > summary')
                  ?.setAttribute('aria-expanded', 'false');
              });

            details.open = willOpen;
            summary.setAttribute('aria-expanded', String(willOpen));
          },
          true
        );
      });
  }

  initialiseGigglzMobileAccordions();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseGigglzMobileAccordions(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
